













// vendor
import { defineComponent, computed, ref, SetupContext } from "@vue/composition-api";
// project
import { ContextOption } from "@/components.generic/context-menu";
import * as AppModal from "@/AppModal";
import { getAssetTypes } from "@/psychlab/meta";
import { pascalToSentenceCase } from "@/utils/text";
// local
import * as create from "./create";

import { useTranslate } from "@lang";

const assetAlias:any = {
	"Graph":"Blueprint",
};

const assetOrder:any = {
	"Graph":1,
};

const getAssetOptions = (context:SetupContext):ContextOption[] => {

	const { translate } = useTranslate();

	const types = getAssetTypes().filter(t => !t.disabled);
	
	const options:ContextOption[] = types.map(at => {
		const name = pascalToSentenceCase(assetAlias[at.name] || at.name);
		return {
			name:translate(`assets.label.${name.toLowerCase()}`),
			icon:at.icon,
			fn:() => create.createAsset(at.name, context),
			order:assetOrder[at.name] !== undefined ? assetOrder[at.name] : 2,
		};
	});
	return options;
};

export default defineComponent({

	emits:[],
	props:{
		size:{
			type:Number,
			default:1.75,
		}
	},
	components:{
	},
	setup(props, context){


		const { translate } = useTranslate();
		
		const btnStyle = computed(() => {
			return `width:${props.size}em;height:${props.size}em;font-size:${props.size * 0.8}em;`
		});


		const onAdd = (e:Event) => {

			const options:ContextOption[] = [
				...getAssetOptions(context),
			];

			options.push({
				name:translate("studies.label.study"),
				icon:"mdi.rocket mdi-rotate-45",
				fn(){
					create.createStudy(context);
				}
			})

			AppModal.context(e, options);


		};

		return {
			btnStyle,
			onAdd,
		};
	}
});

